/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  // 移除权限控制，允许所有用户访问
  return {
    canAdmin: true,
  };
}
